import styles from './Tabs.css';
import { ITab, Tab } from './components/Tab';

interface ITabsProps<T> {
  items: ITab<T>[];
  activeValue: T;
  onClick(value: T): void;
}

export function Tabs<T>({ items, activeValue, onClick }: ITabsProps<T>) {
  return (
    <div className={styles['tabs-container']}>
      {items.map(item => (
        <Tab {...item} active={item.value === activeValue} key={`${item.value}`} onClick={onClick} />
      ))}
    </div>
  );
}
